import { createFileRoute } from "@tanstack/react-router";

import { Versions } from "@/features/publisher";

export const Route = createFileRoute("/publisher/")({
  component: Versions,
});
